module.exports = __webpack_public_path__ + "static/media/galerija_2014 (35).d374e85f.jpg";